// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2TRSH","productName":"Table_productName__1vfIX"};